import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { FormattedMessage } from 'react-intl'

import Box from 'app/components/base/Box'
import Button from 'app/components/base/Button'
import Container from 'app/components/base/Container'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

const GreenLinesSVG = dynamic(
  () => import('app/assets/images/help-center/green-lines.svg')
)

const DidNotFindBlock = () => {
  const { push } = useRouter()

  return (
    <Box sx={{ backgroundColor: 'background.dark', maxHeight: { md: 212 } }}>
      <Container
        maxWidth="md"
        sx={{
          px: 3,
          py: { xs: 4, md: 0 },
          pl: { md: 8 },
          position: 'relative',
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Stack direction="column" spacing={3} sx={{ justifyContent: 'center' }}>
          <Stack direction="column" spacing={2}>
            <Text variant="h2">
              <FormattedMessage defaultMessage="Didn't find an answer?" />
            </Text>

            <Text variant="body1" sx={{ color: 'text.third' }}>
              <FormattedMessage defaultMessage="Contact us for personalized service and assistance" />
            </Text>
          </Stack>

          <Button
            variant="contained"
            onClick={() => push('/contact-us')}
            sx={{ maxWidth: 160 }}
          >
            <FormattedMessage defaultMessage="Contact us" />
          </Button>
        </Stack>

        <Box
          sx={{
            display: { xs: 'none', md: 'block' },
            position: 'relative',
            left: { md: 20, lg: 40 }
          }}
        >
          <GreenLinesSVG />
        </Box>
      </Container>
    </Box>
  )
}

export default DidNotFindBlock
